import type { ScanErrorCode, ScanResult } from './types';

export class ScanError extends Error {
  readonly code: ScanErrorCode;

  constructor(code: ScanErrorCode) {
    super(code);
    this.name = 'ScanError';
    this.code = code;
  }
}

export interface ScanProgress {
  /** 0-100, as the scanner reports it. */
  percent: number;
  /** What the scanner is doing right now (its own wording, English). */
  task: string;
}

export interface ScanAdapter {
  /**
   * Runs one scan. Calls `onProgress` as the scanner reports, resolves with the result and
   * rejects with a `ScanError` (anything else is treated as UNKNOWN). Must stop quietly
   * when `signal` aborts.
   */
  run(host: string, onProgress: (p: ScanProgress) => void, signal: AbortSignal): Promise<ScanResult>;
}
